import React from 'react';
import ReactDOM from 'react-dom/client';
import { Capacitor } from '@capacitor/core';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import { UserProvider } from './contexts/UserContext';
import { OnboardingQuickstartProvider } from './contexts/OnboardingQuickstartContext';
import { MembershipProvider } from './contexts/MembershipContext';
import { AdminProvider } from './contexts/AdminContext';
import FirstMatchProvider from './contexts/FirstMatchProvider';
import TradeCompleteProvider from './contexts/TradeCompleteProvider';
import { PullToRefreshProvider } from './contexts/PullToRefreshContext';

// Native (Capacitor) only: tag <html> so platform-specific CSS can target the
// app build without affecting the web app. Used by index.css to enforce 16px
// form fields (prevents iOS auto-zoom on focus). No-op on web.
if (Capacitor.isNativePlatform()) {
  document.documentElement.classList.add('capacitor-native');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <UserProvider>
          <OnboardingQuickstartProvider>
            <MembershipProvider>
              <AdminProvider>
                <FirstMatchProvider>
                  <TradeCompleteProvider>
                    <PullToRefreshProvider>
                      <App />
                    </PullToRefreshProvider>
                  </TradeCompleteProvider>
                </FirstMatchProvider>
              </AdminProvider>
            </MembershipProvider>
          </OnboardingQuickstartProvider>
        </UserProvider>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);


